import { createClasses } from '@classroom-ai/ui/theme/create-classes';

// ----------------------------------------------------------------------

export const svgColorClasses = {
  root: createClasses('svg__color__root'),
};
